var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('myheader'),_vm._v(" "),_c('mynav'),_vm._v(" "),_c('home'),_vm._v(" "),_c('mysub'),_vm._v(" "),_c('single'),_vm._v(" "),_c('componcon'),_vm._v(" "),_c('common'),_vm._v(" "),_c('recommend'),_vm._v(" "),_c('hotreview'),_vm._v(" "),_c('mycontent'),_vm._v(" "),_c('server'),_vm._v(" "),_c('foot')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-477123e0","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 74
// module chunks = 0